import { render } from "./TheSidebar.vue?vue&type=template&id=aa49df8a&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import "./TheSidebar.vue?vue&type=style&index=0&id=aa49df8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aa49df8a"

export default script